import React from 'react';
import './SigningLoader.css';

/**
 * SignTada Loader v2: flowing signature path + realistic pen moving like signing.
 * size: "sm" | "md" | "lg" – controls SVG and label size.
 * label: optional text below; omit or "" for spinner only (e.g. in buttons).
 */
function SigningLoader({ size = 'md', label }) {
  const message = label != null ? label : 'Loading...';
  return (
    <div className={`signing-loader signing-loader--${size}`} role="status" aria-live="polite" aria-label={message || 'Loading'}>
      <svg className="signing-loader__svg" viewBox="0 0 120 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {/* Single flowing signature: gentle cursive, one line */}
        <path
          className="sig-path"
          d="M8,30 C12,22 16,34 22,28 C26,24 29,18 34,22 C38,26 40,20 46,24 C52,28 54,18 60,22 C65,26 68,20 74,23 C79,26 82,21 88,24 C92,26 96,23 102,25"
        />
        {/* Pen group: realistic pen, tip points bottom-right, rotate(40deg) */}
        <g className="pen-group">
          <circle className="ink-glow" cx="0" cy="0" r="5" />
          <circle className="ink-dot" cx="0" cy="0" r="1.4" />
          <polygon className="pen-nib-dark" points="0,0 3,-5 1,-5" />
          <polygon className="pen-nib" points="0,0 1,-5 3,-5 2,-3" />
          <rect className="pen-section" x="1" y="-11" width="3.5" height="7" rx="0.5" />
          <line className="pen-grip-tex" x1="1" y1="-7" x2="4.5" y2="-7" stroke="rgba(0,0,0,0.15)" strokeWidth="0.5" />
          <line className="pen-grip-tex" x1="1" y1="-9" x2="4.5" y2="-9" stroke="rgba(0,0,0,0.15)" strokeWidth="0.5" />
          <rect className="pen-barrel" x="0.5" y="-26" width="4.5" height="16" rx="1.2" />
          <rect className="pen-shine" x="1" y="-25" width="1.2" height="13" rx="0.6" />
          <rect className="pen-clip" x="0.5" y="-32" width="4.5" height="7" rx="1.8" />
          <rect style={{ fill: 'rgba(0,0,0,0.18)' }} x="2.8" y="-31" width="1" height="6" rx="0.4" />
        </g>
      </svg>
      {message ? <span className="signing-loader__label">{message}</span> : null}
    </div>
  );
}

export default SigningLoader;
